import { render, staticRenderFns } from "./systemParams.vue?vue&type=template&id=06a76b41&scoped=true"
import script from "./systemParams.vue?vue&type=script&lang=js"
export * from "./systemParams.vue?vue&type=script&lang=js"
import style0 from "./systemParams.vue?vue&type=style&index=0&id=06a76b41&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a76b41",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\yl\\yl-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06a76b41')) {
      api.createRecord('06a76b41', component.options)
    } else {
      api.reload('06a76b41', component.options)
    }
    module.hot.accept("./systemParams.vue?vue&type=template&id=06a76b41&scoped=true", function () {
      api.rerender('06a76b41', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bigScreen/components/systemParams.vue"
export default component.exports